module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-message', {
    attrs: {
      "title": "Info",
      "type": "is-info",
      "aria-close-label": "Close message"
    }
  }, [_vm._v("\n    На данный момент можно посмотреть параметры в пределах текущего месяца, ниже можно выбрать период, по умолчанию\n    это начало и конец текущего месяца\n  ")]), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Select start period date of current month"
    }
  }, [_c('b-datepicker', {
    attrs: {
      "rounded": "",
      "size": "is-medium",
      "placeholder": "Click to select...",
      "min-date": _vm.getFirstDayOfCurrentMonth(),
      "max-date": _vm.getLastDayOfCurrentMonth()
    },
    model: {
      value: (_vm.startPeriodDate),
      callback: function($$v) {
        _vm.startPeriodDate = $$v
      },
      expression: "startPeriodDate"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Select end period date of current month"
    }
  }, [_c('b-datepicker', {
    attrs: {
      "rounded": "",
      "size": "is-medium",
      "placeholder": "Click to select...",
      "min-date": _vm.getFirstDayOfCurrentMonth(),
      "max-date": _vm.getLastDayOfCurrentMonth()
    },
    model: {
      value: (_vm.endPeriodDate),
      callback: function($$v) {
        _vm.endPeriodDate = $$v
      },
      expression: "endPeriodDate"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": !!_vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.loadAggregateDataForPeriod()
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("Загрузить данные")])])]), _vm._v(" "), (_vm.summaryData) ? _c('div', {
    staticClass: "summary-container"
  }, [_c('div', {
    staticClass: "client-summary"
  }, [_c('h2', {
    staticClass: "client-summary-title"
  }, [_vm._v(" " + _vm._s(_vm.summaryData.clientName))]), _vm._v(" "), (_vm.summaryData.clientSummary) ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('h2', [_vm._v("Затрачено за период по всем кампаниям")]), _vm._v(" "), _c('table', {
    staticClass: "table is-bordered"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.summaryData.clientSummary), function(value, name) {
    return _c('tr', {
      key: name
    }, [_c('td', {
      staticClass: "td-resource"
    }, [_vm._v(_vm._s(name))]), _vm._v(" "), _c('td', {
      staticClass: "td-value"
    }, [_vm._v(_vm._s(value))])])
  }), 0)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "campaigns-summary-container"
  }, _vm._l((_vm.summaryData.campaignSummaryList), function(item) {
    return _c('div', {
      key: item.campaignName,
      staticClass: "campaigns-summary-item"
    }, [_c('div', {
      staticClass: "campaigns-summary-item-title"
    }, [_vm._v(" " + _vm._s(item.campaignName))]), _vm._v(" "), _c('div', {
      staticClass: "campaigns-summary-item-data"
    }, [(item.campaignSummary) ? _c('div', {
      staticClass: "table-responsive"
    }, [_c('h2', [_vm._v("Затрачено за период по кампании")]), _vm._v(" "), _c('table', {
      staticClass: "table is-bordered"
    }, [_vm._m(2, true), _vm._v(" "), _c('tbody', _vm._l((item.campaignSummary), function(value, name) {
      return _c('tr', {
        key: name
      }, [_c('td', {
        staticClass: "td-resource"
      }, [_vm._v(_vm._s(name))]), _vm._v(" "), _c('td', {
        staticClass: "td-value"
      }, [_vm._v(_vm._s(value))])])
    }), 0)])]) : _vm._e()])])
  }), 0)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Ресурс")]), _vm._v(" "), _c('th', [_vm._v("Значение")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Ресурс")]), _vm._v(" "), _c('th', [_vm._v("Значение")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b9a7b77"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/billing/BillingSummaryDashboard.vue
// module id = 394
// module chunks = 42